import React, { PureComponent } from 'react';

import CoreFormContext from '../../contexts/Form';

import { CoreFormButtonProps } from '../../interfaces/';
import { CoreFormEventsEnum } from '../../enums/';
import { SAVE_PROPS, FORM_EVENT_DELAY } from '../../constants/';
import { HashMapMergeProps, WaitForDelay } from '../../../../../utils/';

/**
 * Save Container
 * @export
 * @class CoreFormSaveContainer
 * @extends {PureComponent<CoreFormButtonProps, {}>}
 */
export default class CoreFormSaveContainer extends PureComponent<CoreFormButtonProps, {}> {
  /**
   * Form Context
   * @static
   * @type {Readonly<typeof CoreFormContext>}
   * @memberof CoreFormSaveContainer
   */
  public static contextType: Readonly<typeof CoreFormContext> = CoreFormContext;

  /**
   * Default Props
   * @static
   * @type {CoreFormButtonProps}
   * @memberof CoreFormSaveContainer
   */
  public static defaultProps: CoreFormButtonProps = HashMapMergeProps(SAVE_PROPS);

  /**
   * Abort Controller
   * @private
   * @type {AbortController}
   * @memberof CoreFormSaveContainer
   */
  protected listener: AbortController;

  /**
   * LifeCycle Hook
   * @memberof CoreFormSaveContainer
   */
  public componentDidMount() {
    const { FormEventListener, context } = this;
    this.listener = new AbortController();
    context.emitter.on(CoreFormEventsEnum.FORM_EVENT_UPDATE, FormEventListener);
    context.emitter.on(CoreFormEventsEnum.FORM_EVENT_RESET, FormEventListener);
    context.emitter.on(CoreFormEventsEnum.FORM_EVENT_SUBMIT, FormEventListener);
  }

  /**
   * LifeCycle Hook
   * @memberof CoreFormSaveContainer
   */
  public componentWillUnmount() {
    const { FormEventListener, context, listener } = this;
    listener.abort();
    context.emitter.off(CoreFormEventsEnum.FORM_EVENT_UPDATE, FormEventListener);
    context.emitter.off(CoreFormEventsEnum.FORM_EVENT_RESET, FormEventListener);
    context.emitter.off(CoreFormEventsEnum.FORM_EVENT_SUBMIT, FormEventListener);
  }

  /**
   * Render
   * @returns
   * @memberof CoreFormSaveContainer
   */
  public render() {
    const { props: { label, type }, context: { validate, valid, dirty } } = this;
    const disabled: boolean = validate ? (valid === false || dirty === false) : false;
    return <nux-button-primary type={type} disabled={disabled} tabIndex={-1}>{label}</nux-button-primary>;
  }

  /**
   * Form Event Listener
   * @protected
   * @memberof CoreFormSaveContainer
   */
  /* istanbul ignore next */
  protected FormEventListener = (): void => {
    WaitForDelay(FORM_EVENT_DELAY).then(() => {
      if (!this.listener.signal.aborted) {
        this.forceUpdate();
      }
    });
  };
}
